/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { Button } from "@mui/material";
import { useContentZone } from "cms/components/hooks/use-content-zone";

const NoComponentEditorAvailable = (props) => {
    
    const { fieldName, component, editMode } = props || {};
    const { type, guid } = component || {};
    const { handleDeleteComponent } = useContentZone();
    
    const onRemoveComponent = async () => {
        await handleDeleteComponent(fieldName, component);
    };
    
    return (
        <div className='simplicity-missing-type'>
            <span className="penguin">&#128039;</span>
            <p>Component Type: {type}</p>
            <p>Component Guid: {guid}</p>
            <p>This SimpliCity component type is not implemented for editing.</p>
            {editMode &&
                <Button
                    onClick={onRemoveComponent}
                    sx={{ margin: "12px" }}
                    variant='outlined'
                    color='inherit'
                >
                    Remove
                </Button>
            }
        </div>
    );
};

export { NoComponentEditorAvailable };
